define("settings/controllers/subscription/billing", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/controller", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/tracking", "ember-concurrency", "shared/utils/create-tax-id-changeset"], function (_exports, _asyncArrowRuntime, _controller, _object, _service, _utils, _tracking, _emberConcurrency, _createTaxIdChangeset) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/tracking",0,"ember-concurrency",0,"shared/utils/create-tax-id-changeset"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let BillingController = _exports.default = (_dec = (0, _service.inject)('chatbot/chatbot-wrapper'), (_class = class BillingController extends _controller.default {
    // Set in route setupController hook

    constructor(properties) {
      super(properties);
      _initializerDefineProperty(this, "address", _descriptor, this);
      _initializerDefineProperty(this, "alerts", _descriptor2, this);
      _initializerDefineProperty(this, "auth", _descriptor3, this);
      _initializerDefineProperty(this, "events", _descriptor4, this);
      _initializerDefineProperty(this, "intl", _descriptor5, this);
      _initializerDefineProperty(this, "payment", _descriptor6, this);
      _initializerDefineProperty(this, "router", _descriptor7, this);
      _initializerDefineProperty(this, "segment", _descriptor8, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor9, this);
      _initializerDefineProperty(this, "chatbotWrapper", _descriptor10, this);
      _defineProperty(this, "MILLISECONDS_REQUIRED_FOR_ACCOUNT_UPDATE", 4000);
      _initializerDefineProperty(this, "taxIdData", _descriptor11, this);
      _initializerDefineProperty(this, "taxIdChangeset", _descriptor12, this);
      _initializerDefineProperty(this, "didAddNewCard", _descriptor13, this);
      _defineProperty(this, "didSaveTaxId", false);
      _defineProperty(this, "queryParams", ['update_card_origin']);
      _defineProperty(this, "update_card_origin", 'no_previous_prompt');
      _defineProperty(this, "handleAccountUpdate", async () => {
        if (!this.didSaveTaxId) {
          return;
        }
        const taxIds = Object.values(this.currentAccount.taxIds);
        if ((0, _utils.isEmpty)(taxIds)) {
          return;
        }
        if (taxIds.every(id => id.status === 'verified')) {
          await this.loadTaxId.perform();
          this.alerts.success(this.intl.t('checkout.tax.tax_id.success_alert.description'), {
            title: this.intl.t('checkout.tax.tax_id.success_alert.title')
          });
          this.router.transitionTo('account.subscription.billing');
          this.didSaveTaxId = false;
        }
        if (taxIds.every(id => id.status === 'unverified')) {
          // Not calling loadTaxId as that will overwrite the form state
          this.taxIdData = await this.payment.retrieveTaxIds.perform();
          // We can get 2 account update events, in order to not show 2 alerts, wait until the tax id is not pending
          if (!(this.taxIdData?.status === 'pending')) {
            this.alerts.warning(this.intl.t('checkout.tax.tax_id.invalid_alert.description'), {
              title: this.intl.t('checkout.tax.tax_id.invalid_alert.title')
            });
            this.didSaveTaxId = false;
          }
        }
      });
      _defineProperty(this, "onTaxIdFormSubmit", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          try {
            this.segment.track('tax-id-applied-in-settings', {
              tax_id_type: 'GB-VAT'
            });
            const {
              success
            } = yield this.currentAccount.updateTaxId({
              vat_business: this.taxIdChangeset?.businessName,
              vat_number: this.taxIdChangeset?.taxId
            });
            if (!success) {
              this.alerts.warning(this.intl.t('alerts.errors.generic'));
            } else {
              this.didSaveTaxId = true;
              this.taxIdChangeset?.save();
              // Need to reload tax id to get pending state
              this.taxIdData = yield this.payment.retrieveTaxIds.perform();
            }
          } catch (e) {
            this.alerts.warning(this.intl.t('alerts.errors.generic'));
          }
        }
      }), null, "onTaxIdFormSubmit", null));
      _defineProperty(this, "loadTaxId", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.taxIdData = yield this.payment.retrieveTaxIds.perform();
          this.taxIdChangeset = (0, _createTaxIdChangeset.default)(this.taxIdData);
        }
      }), null, "loadTaxId", null));
      this.loadTaxId.perform();
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get creditCard() {
      if (!this.subscriptions.hasCurrentSubscription) {
        return;
      }
      return this.payment.paymentMethod;
    }
    get payments() {
      return this.payment.payments;
    }
    get businessName() {
      return this.taxIdData?.businessName ?? '';
    }
    get hasTaxIdError() {
      return this.taxIdData?.status === 'unverified' || this.auth.currentAccount.hasInvalidTaxId;
    }
    get shouldShowExpiringPaymentMethodError() {
      return this.payment.hasUpcomingExpiringPaymentMethod && !this.didAddNewCard;
    }
    get isEnterpriseSubscription() {
      return this.subscriptions.isEnterpriseSubscription;
    }
    get isLoadingTaxId() {
      return this.loadTaxId.isRunning;
    }
    get isTaxIdPending() {
      return this.taxIdData?.status === 'pending' || this.taxIdData?.status === 'unavailable';
    }
    get taxId() {
      return this.taxIdData?.value ?? '';
    }
    get hasSavedAddress() {
      return this.address.isSavedAddressValid;
    }
    get rolloutBillingForms() {
      return this.currentAccount.rolloutBillingForms;
    }
    get showAddress() {
      return this.address.addressCollectionEnabledInSettings;
    }
    get shouldDisplayTaxId() {
      return Boolean(this.address.shouldDisplayTaxAmount && !this.isLoadingTaxId || this.taxId || this.hasTaxIdError);
    }
    openChatbot() {
      this.chatbotWrapper.open();
    }
    setupEvents() {
      this.events.on('account:updated', this.handleAccountUpdate);
    }
    teardownEvents() {
      this.events.off('account:updated', this.handleAccountUpdate);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "events", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "payment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "chatbotWrapper", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "taxIdData", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "taxIdChangeset", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "didAddNewCard", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "openChatbot", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openChatbot"), _class.prototype)), _class));
});